import { GridApiCommon, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { DateTime } from "luxon";
import { memo } from "react";
import { TbHeartHandshake } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import MemoizedEditableColumn from "@/components/table/EditableColumn";
import TimeCellEditor from "@/components/table/TimeCellEditor";
import { PassengersGroupTableRow } from "@/types/tasks.types";

export function PlanPickupCell({ value }: { value: DateTime | string | undefined }) {
    const date = value instanceof DateTime ? value : DateTime.fromISO(value as string);
    return <span className="font-medium"> {date && date.toFormat("HH:mm")}</span>;
}

const MemoComponent = memo(
    ({
        value,
        row,
        field,
        api,
        editable,
    }: {
        api: GridApiCommon;
        field: string;
        row: PassengersGroupTableRow;
        value: DateTime;
        editable: boolean;
    }) => {
        return (
            <MemoizedEditableColumn
                renderHistoryComp={(val) => <PlanPickupCell value={val as DateTime | undefined} />}
                api={api}
                field={field}
                id={row.id}
                editable={editable}
            >
                <PlanPickupCell value={value} />
            </MemoizedEditableColumn>
        );
    }
);

export const PlanPickupColumn = ({
    t,
    editable,
}: {
    t: TFunction;
    editable: boolean;
}): GridColDef<PassengersGroupTableRow> => {
    return {
        field: "pickUp",
        headerName: t("pickUp"),
        minWidth: 100,
        editable,
        renderHeader: (params) => <TableHeader Component={TbHeartHandshake} title={params.colDef.headerName!} />,
        valueGetter: (_val, row) => row.pickUp,
        renderCell: (params: GridRenderCellParams<PassengersGroupTableRow>) => (
            <MemoComponent
                editable={editable}
                api={params.api}
                row={params.row}
                field={params.field}
                value={params.value}
            />
        ),
        renderEditCell: (params) => <TimeCellEditor {...params} field="pickUp" />,
    };
};
